<script lang="ts">
  /**
   * "Play this duel in the app" hand-off — web duels are view-only, so every
   * play action (claim / vote) routes to the iOS app via the universal link
   * `https://beatduel.com/duels/{id}` (AASA intercepts it on iOS; on web it
   * just reloads the duel page). `compact` renders the slim variant.
   */
  import { addToast } from '$shared/toasts.svelte';

  let {
    duelId,
    label = 'Play this duel in the app',
    compact = false,
  }: { duelId: number; label?: string; compact?: boolean } = $props();

  const universalLink = $derived(`https://beatduel.com/duels/${duelId}`);

  function copyLink() {
    navigator.clipboard.writeText(universalLink);
    addToast('Link copied!', 'join');
  }
</script>

<div class="app-cta" class:app-cta--compact={compact}>
  <a href={universalLink} class="app-cta__main">
    <span class="app-cta__label">{label}</span>
    <span class="app-cta__arrow" aria-hidden="true">&rarr;</span>
  </a>
  <button type="button" class="app-cta__copy" onclick={copyLink}>Copy link</button>
</div>

<style>
  .app-cta {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex-wrap: wrap;
    margin: 1rem 0;
    padding: 0.9rem 1.1rem;
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: var(--radius-lg);
    position: relative;
    overflow: hidden;
  }
  .app-cta::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(135deg, var(--pink) 0%, var(--purple) 100%);
  }
  .app-cta--compact {
    padding: 0.5rem 0.75rem;
    margin: 0.75rem 0;
    border-radius: var(--radius);
  }
  .app-cta--compact::before {
    height: 2px;
  }
  .app-cta__main {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 700;
    color: var(--text);
    flex: 1;
    min-width: 0;
  }
  .app-cta--compact .app-cta__main {
    font-size: 0.875rem;
    font-weight: 600;
  }
  .app-cta__main:hover .app-cta__label {
    color: var(--pink);
  }
  .app-cta__arrow {
    color: var(--pink);
    flex-shrink: 0;
  }
  .app-cta__copy {
    background: transparent;
    border: 1px solid var(--border);
    border-radius: 999px;
    color: var(--text-muted);
    font-size: 0.75rem;
    font-weight: 600;
    padding: 0.3rem 0.75rem;
    cursor: pointer;
    white-space: nowrap;
  }
  .app-cta__copy:hover {
    color: var(--text);
    border-color: var(--text-muted);
  }
</style>
